export default "__VITE_ASSET__BvdsB6QR__"